<template>
    <auth-card-template :large="true">
        <card-auth logo-link="#">
            <div class="text-center mb-6">
                <h4 class="font-family-title font-weight-bold text-primary mb-4">
                    Torne-se um parceiro da Hostoo!
                </h4>
            </div>

            <p class="mb-6" v-show="acceptance === null">
                Olá, tudo bem? Nossa equipe analisou o seu perfil e selecionamos você para uma reunião de parceria
                com o time da Hostoo. Desejamos que nossos clientes cresçam junto conosco e você pode ser uma parte
                essencial disso! <strong>Gostaria de agendar um horário conosco?</strong>
            </p>

            <div class="text-center">
                <button ref="btnYes" type="button" class="btn btn-lg btn-success" @click="showScheduleForm">
                    Sim, desejo agendar!
                </button>
                <button ref="btnNo" type="button" class="btn btn-lg btn-light ml-2" @click="showRefusalForm">
                    No momento, não.
                </button>
            </div>

            <div v-show="acceptance === true" class="mt-4">
                <p>
                    Agradecemos pelo seu interesse em estabelecer uma parceria conosco! Valorizamos muito a sua opinião
                    e queremos garantir que atenderemos às suas necessidades da melhor maneira possível.
                </p>

                <!-- Calendly - BEGIN -->
                <div v-show="isCalendlyLoaded" class="text-center">
                    <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        v-bind:class="{ 'btn-loading': isCalendlyLoading }"
                        :disabled="isCalendlyLoading"
                        @click="showCalendlyPopup"
                    >
                        Clique e agende um horário!
                    </button>

                    <div v-show="showRedirectButton" class="mt-6">
                        <a class="text-muted" href="/">
                            Voltar para o painel da Hostoo
                        </a>
                    </div>
                </div>
                <!-- Calendly - END -->

                <form v-show="isCalendlyError" @submit.prevent="sendPartnerFeedback">
                    <form-group label="E-mail" labelFor="partnerEmail" :error="formErrors.email">
                        <input
                            type="email"
                            id="partnerEmail"
                            class="form-control"
                            spellcheck="false"
                            autocomplete="email"
                            placeholder="Informe seu melhor e-mail"
                            v-model="formData.email"
                        />
                    </form-group>

                    <form-group label="Celular / Telefone" labelFor="partnerPhone" :error="formErrors.phone">
                        <the-mask
                            type="tel"
                            id="partnerPhone"
                            class="form-control"
                            placeholder="(00) 00000-0000"
                            autocomplete="tel-national"
                            :mask="['(##) ####-####', '(##) #####-####']"
                            v-model="formData.phone"
                        />
                    </form-group>

                    <form-group label="Sugestão de data" label-for="partnerScheduleDate" :error="formErrors.scheduleDate">
                        <input
                            type="date"
                            id="partnerScheduleDate"
                            class="form-control"
                            aria-label="Sugestão de data da reunião"
                            v-model="formData.scheduleDate"
                        />
                    </form-group>

                    <form-group label="Melhor horário" label-for="partnerScheduleTime" :error="formErrors.scheduleTime">
                        <select id="partnerScheduleTime" class="form-control custom-select" v-model="formData.scheduleTime">
                            <option value="M">Manhã (08h - 12h)</option>
                            <option value="A">Tarde (14h - 18h)</option>
                        </select>
                    </form-group>

                    <div class="mt-4">
                        <button-form ref="btnSchedule" type="submit" theme="success" class="btn-lg btn-block">Enviar</button-form>
                    </div>
                </form>
            </div>

            <form v-show="acceptance === false" class="mt-4" @submit.prevent="sendPartnerFeedback">
                <p>
                    Entendemos que pode haver diversas razões pelas quais você optou por não agendar uma reunião de
                    parceria neste momento. Sua opinião é extremamente importante para nós e gostaríamos de saber o
                    motivo pelo qual não deseja continuar.
                </p>

                <form-group label="Motivo da recusa" label-for="refusalReason" :error="formErrors.refusalReason">
                    <select id="refusalReason" class="form-control custom-select" v-model="formData.refusalReason">
                        <option value="NO_INTEREST">Não desejo parceria</option>
                        <option value="NO_TIME">Estou sem tempo</option>
                        <option value="TESTING">Estou apenas testando a plataforma</option>
                        <option value="OTHER">Outro motivo...</option>
                    </select>
                </form-group>

                <form-group
                    v-show="formData.refusalReason == 'OTHER'"
                    label="Outro motivo"
                    label-for="reasonOther"
                    :error="formErrors.reasonOther"
                >
                    <textarea
                        id="reasonOther"
                        class="form-control"
                        rows="4"
                        maxlength="500"
                        placeholder="Descreva em poucas palavras o motivo da recusa..."
                        spellcheck="false"
                        v-model="formData.reasonOther">
                    </textarea>
                </form-group>

                <div class="mt-4">
                    <button-form ref="btnRefuse" type="submit" theme="secondary" class="btn-lg btn-block">Enviar</button-form>
                </div>
            </form>
        </card-auth>
    </auth-card-template>
</template>

<script>
    import CardAuth from "@/components/organisms/CardAuth.vue";
    import AuthCardTemplate from "@/components/templates/AuthCardTemplate.vue";
    import FormGroup from "@/components/molecules/FormGroup.vue";
    import ButtonForm from "@/components/atoms/ButtonForm.vue";
    import ErrorService from "@/services/ErrorService";
    import {mapActions, mapState} from "vuex";

    export default {
        components: {
            ButtonForm,
            FormGroup,
            CardAuth,
            AuthCardTemplate
        },
        data() {
            return {
                acceptance: null,
                formData: {},
                formErrors: {},
                isCalendlyLoaded: false,
                isCalendlyError: false,
                showRedirectButton: false,
            }
        },
        computed: {
            ...mapState("user", ["user"]),

            isCalendlyLoading: function () {
                return !this.isCalendlyLoaded && !this.isCalendlyError;
            }
        },
        created()
        {
            this.loadCalendly();
            this.fetchUser();
        },
        methods: {
            ...mapActions({
                fetchUser: 'user/fetchUser',
            }),

            loadCalendly()
            {
                // Load JS
                const script = document.createElement("script");

                script.onload = () => {
                    this.isCalendlyLoaded = true;
                };

                script.onerror = () => {
                    this.isCalendlyError = true;
                };

                script.type  = "text/javascript";
                script.src   = "https://assets.calendly.com/assets/external/widget.js";
                script.id    = "js-calendly";
                script.async = true;

                if (!document.getElementById("js-calendly")) {
                    document.head.appendChild(script);
                }

                // Load CSS
                const css  = document.createElement("link");
                css.type = "text/css";
                css.rel  = "stylesheet";
                css.href = "https://assets.calendly.com/assets/external/widget.css";
                css.id   = "css-calendly";

                if (!document.getElementById("css-calendly")) {
                    document.head.appendChild(css);
                }
            },

            showCalendlyPopup()
            {
                if (typeof window.Calendly !== "undefined")
                {
                    Calendly.initPopupWidget({
                        url: "https://calendly.com/hostoo/call",
                        prefill: {
                            name: this.user ? this.user.name : "",
                            email: this.user ? this.user.email : "",
                            customAnswers: "",
                        }
                    });
                }

                setTimeout(() => { this.showRedirectButton = true; }, 5000);

                return false;
            },

            showScheduleForm()
            {
                this.formData = { acceptance: true };
                this.acceptance = true;
                this.showRedirectButton = false;
            },

            showRefusalForm()
            {
                this.formData = { acceptance: false };
                this.acceptance = false;
            },

            sendPartnerFeedback()
            {
                this.formErrors = {};
                this.$refs.btnSchedule.loadingFocus();
                this.$refs.btnRefuse.loadingFocus();

                this.$api.post('/user/partner', this.formData)
                    .then (() => {
                        window.location.href = "/";
                    })
                    .catch(error => {
                        ErrorService.handleFormError(error, this);
                        this.$refs.btnSchedule.setLoading(false);
                        this.$refs.btnRefuse.setLoading(false);
                    });
            }
        }
    }
</script>
